export default __webpack_public_path__ + "static/media/company-user.85401183.png";